import {
  ChartBarIcon,
  InformationCircleIcon,
} from '@heroicons/react/outline'
import { GAME_TITLE } from '../../constants/strings'
import { LogoIcon } from '../../icons'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
}
export const Information = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
}: Props) => (
  <div className="px-10 my-2.5">
    <div className="flex justify-between">
      <div className="flex items-center">
        <LogoIcon />
        <p className="text-xl ml-2.5 font-bold dark:text-white">{GAME_TITLE}</p>
      </div>
      <div className="right-icons">
        <InformationCircleIcon
          className="h-6 w-6 mr-2 cursor-pointer dark:stroke-white"
          onClick={() => setIsInfoModalOpen(true)}
        />
        <ChartBarIcon
          className="h-6 w-6 mr-3 cursor-pointer dark:stroke-white"
          onClick={() => setIsStatsModalOpen(true)}
        />
      </div>
    </div>
  </div>
);
